"use client"

import { useCallback } from "react"
import type { PasswordData } from "../types/account-details"
import { ACCOUNT_CONSTANTS } from "../constants/account-details"

export const usePasswordValidation = () => {
  const validatePasswords = useCallback((passwordData: PasswordData): string | null => {
    if (!passwordData.oldPassword) {
      return ACCOUNT_CONSTANTS.ERROR_MESSAGES.OLD_PASSWORD_REQUIRED
    }

    if (!passwordData.newPassword) {
      return ACCOUNT_CONSTANTS.ERROR_MESSAGES.NEW_PASSWORD_REQUIRED
    }

    if (!passwordData.confirmPassword) {
      return ACCOUNT_CONSTANTS.ERROR_MESSAGES.CONFIRM_PASSWORD_REQUIRED
    }

    if (passwordData.newPassword.length < ACCOUNT_CONSTANTS.VALIDATION.MIN_PASSWORD_LENGTH) {
      return ACCOUNT_CONSTANTS.ERROR_MESSAGES.PASSWORD_TOO_SHORT
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      return ACCOUNT_CONSTANTS.ERROR_MESSAGES.PASSWORDS_DONT_MATCH
    }

    if (passwordData.oldPassword === passwordData.newPassword) {
      return ACCOUNT_CONSTANTS.ERROR_MESSAGES.SAME_PASSWORD
    }

    return null
  }, [])

  return { validatePasswords }
}
